var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownloadColor = function SvgDownloadColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.5,
    height: 23.783,
    viewBox: "0 0 27.5 23.783",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(741.876 -408.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M-715.626,425.121v4.061a1.968,1.968,0,0,1-1.962,1.962h-21.076a1.967,1.967,0,0,1-1.962-1.962v-4.061",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    y1: 16.089,
    transform: "translate(-728.136 409.861)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M-721.186,419.038l-6.946,6.935-6.936-6.935",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downloadColor.51781c5c.svg";
export { ForwardRef as ReactComponent };